import { render, staticRenderFns } from "./FacetSelectedFilters.vue?vue&type=template&id=3dcb7ae6&"
import script from "./FacetSelectedFilters.vue?vue&type=script&lang=js&"
export * from "./FacetSelectedFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports